/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import React from 'react';
import { IHosportsTeamListViewProps } from "../../../modules/hosports-team-list/./hosports-team-list";
//@ts-ignore
import TextOverImageThumbGrid from "./../../../baseComponents/text-over-image-thumb-grid/./text-over-image-thumb-grid";

class HosportsTeamList extends React.Component<IHosportsTeamListViewProps> {
  render() {
    const { config } = this.props;
    let teamList: any = [];
    let columns : any = "4";
    let height : any = "70vh";

    if (config) {
      if (config.athletes) {
        for (let i = 0; i < config.athletes.length; i++) {
          console.log(config.athletes[i]);
          if (config.athletes[i]) {
            let image: any = "";
            if (config.athletes[i].image) {
              if (config.athletes[i].image?.src) {
                image = config.athletes[i].image?.src;
              }
            }
            let link: any = "";
            if (config.athletes[i].link) {
              if (config.athletes[i].link?.linkUrl) {
                if (config.athletes[i].link?.linkUrl?.destinationUrl) {
                  link = config.athletes[i].link?.linkUrl?.destinationUrl;
                }
              }
            }

            teamList.push({
              text: config.athletes[i].Name,
              image: image,
              link: link,
            });
          }
        }
      }
      if(config.columns){
        console.log(config.columns)
        let columnDictinary : any = {
          two:"6",
          three:"4",
          four:"3",
          six:"2"
        }
        columns = columnDictinary[config.columns] ? columnDictinary[config.columns] : "4"
      }
      if(config.height){
        let heightDictinary : any = {
          full:"100vh",
          threeQuarter:"70vh",
          half:"50vh",
          quarter:"25vh"
        }
        height = heightDictinary[config.height] ? heightDictinary[config.height] : "70vh"
      }
    }

    return (
      <div>
        <TextOverImageThumbGrid
          smallColumns={"12"}
          mediumColumns={columns}
          items={teamList}
          height={height}
          verticalPosition="bottom"
        />
      </div>
    );
  }
}

export default HosportsTeamList;
